module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marquee"
  }, [(_vm.tickerInfo.enabled) ? _c('MarqueeTips', {
    class: _vm.tickerSizeClass,
    style: (_vm.tickerStyle),
    attrs: {
      "content": _vm.tickerInfo.message,
      "speed": 10
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f307909c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ticker.vue
// module id = 240
// module chunks = 1